import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/swimmer.gif'


const _withScopeId = n => (_pushScopeId("data-v-d4372fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "progress" }, null, -1))
const _hoisted_4 = {
  key: 0,
  style: {"height":"500px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "center",
  src: _imports_0
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  style: {"height":"300px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "center",
  src: _imports_0
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "overview-table" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Swimtime", -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Round", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Agegroup", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Place", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"vertical-align":"top"} }, "Reason", -1))
const _hoisted_24 = { style: {"white-space":"pre-wrap","word-wrap":"break-word"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Diff. to 1st Place", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Entrytime", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Performance", -1))
const _hoisted_28 = { key: 4 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Reactiontime", -1))
const _hoisted_30 = { key: 5 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Info", -1))
const _hoisted_32 = { key: 6 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Season Best", -1))
const _hoisted_34 = { key: 7 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Alltime Best", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = {
  key: 0,
  class: "live-table"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Splittimes")
  ])
], -1))
const _hoisted_39 = { style: {"text-align":"right"} }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_athletes_table = _resolveComponent("athletes-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.athletesFocus.length > 0)
      ? (_openBlock(), _createBlock(_component_athletes_table, {
          key: 0,
          athletess: _ctx.athletesFocus,
          athleteid: String(_ctx.$route.params.athleteid),
          meetid: String(_ctx.$route.params.meetid)
        }, null, 8, ["athletess", "athleteid", "meetid"]))
      : _createCommentVNode("", true),
    (_ctx.get_swrid_from_athlete_id(String(_ctx.$route.params.athleteid)))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.result)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.get_style_from_event_id(String(_ctx.$route.params.eventid))), 1))
            : (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.get_style_from_event_id(String(_ctx.$route.params.eventid))) + " - No result yet ", 1)),
          _hoisted_3,
          (!_ctx.plotReady)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.wideScreen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_10,
    (_ctx.result)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_13,
                _createElementVNode("td", null, [
                  (_ctx.result.flag)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" new " + _toDisplayString(_ctx.result.flag.text), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.result.swimtime), 1)
                ])
              ]),
              (_ctx.result.points)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.main.points), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.result.points), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.result.masterpoints)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.main.masterpoints), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.result.masterpoints), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.result.handicappoints)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.main.handicappoints), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.result.handicappoints), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", null, _toDisplayString(_ctx.get_round_name_from_event_id(String(_ctx.$route.params.eventid))), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_18,
                _createElementVNode("td", null, _toDisplayString(_ctx.agegroupname), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_19,
                (_ctx.result.place == -1 && _ctx.result.status)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.get_dsq_code_from_status(_ctx.result.status)), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.result.place), 1))
              ]),
              (_ctx.result.place == -1)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.result.commentdsq), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_25,
                _createElementVNode("td", null, _toDisplayString(_ctx.result.diff), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_26,
                _createElementVNode("td", null, _toDisplayString(_ctx.result.entrytime), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_27,
                _createElementVNode("td", null, _toDisplayString(_ctx.get_performance(_ctx.result.swimtime, _ctx.result.entrytime)) + "%", 1)
              ]),
              (_ctx.result.reactiontime)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("td", null, _toDisplayString(_ctx.result.reactiontime), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.result.info)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("td", null, _toDisplayString(_ctx.result.info), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.result.sbest)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("td", null, _toDisplayString(_ctx.result.sbest.swimtime), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.result.pbest)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("td", null, _toDisplayString(_ctx.result.pbest.swimtime), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_36,
          (_ctx.result.splits)
            ? (_openBlock(), _createElementBlock("table", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.splits, (split, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(index), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(split), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, "Result details not yet available for this event.")),
    _hoisted_41,
    _hoisted_42
  ]))
}